<template>
  <v-autocomplete
    v-model="VALOR_SELECIONADO"
    :search-input.sync="txt_novo_email"
    :items="VALOR_SELECIONADO"
    hide-selected
    hide-no-data
    append-icon=""
    multiple
    clearable
    :error-messages="exibir_erro && !TXT_NOVO_EMAIL_VALIDO ? 'E-mail inválido' : errorMessages"
    v-bind="$attrs"
    @keyup.enter="adicionarEmail"
    @blur="adicionarEmail();exibir_erro = false;"
  >
    <template #selection="{attrs, selected, select, item}">
      <v-chip
        v-bind="attrs"
        :input-value="selected"
        close
        small
        @click="select"
        @click:close="removerEmail(item)"
      >
        {{ item }}
      </v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
import {computed, ref, watch} from "vue";
import {email} from "vuelidate/lib/validators";

export default {
  name: "EmailsAutocomplete",
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: ['modelValue', 'errorMessages'],
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const VALOR_SELECIONADO = computed({
      get: () => (props.modelValue || []),
      set: valor => emit('update:modelValue', (valor || [])),
    });

    const txt_novo_email = ref('');
    const ESPACO_BRANCO = ' ';
    watch(
      () => txt_novo_email.value ? txt_novo_email.value[txt_novo_email.value.length - 1] : '',
      ultima_letra => ultima_letra === ESPACO_BRANCO && adicionarEmail(),
    )

    const exibir_erro = ref(false);
    const TXT_NOVO_EMAIL_VALIDO = computed(() => txt_novo_email.value
      && txt_novo_email.value.trim().length > 0
      && email(txt_novo_email.value.trim())
      && !VALOR_SELECIONADO.value.some(email => email === txt_novo_email.value.trim())
    );

    function adicionarEmail() {
      exibir_erro.value = true;
      if (!TXT_NOVO_EMAIL_VALIDO.value) return;
      VALOR_SELECIONADO.value.push(txt_novo_email.value.trim());
      txt_novo_email.value = '';
      exibir_erro.value = false;
    }

    function removerEmail(txt_email) {
      VALOR_SELECIONADO.value = VALOR_SELECIONADO.value.filter(email => email !== txt_email)
    }

    return {
      VALOR_SELECIONADO,
      txt_novo_email,
      adicionarEmail,
      removerEmail,
      TXT_NOVO_EMAIL_VALIDO,
      exibir_erro,
    };
  }
}
</script>

<style scoped>

</style>
